export const paymentMethods = [
    {
        code: 'paypal',
        name: 'Paypal',
        description: 'free of charge',
        logo: {
            code: 'string',
            catalogId: 'string',
            catalogVersion: 'string',
            mime: 'string',
            altText: 'string',
            description: 'string',
            url: 'string',
            downloadUrl: 'string',
        },
        position: 2,
    },
    {
        code: 'visa',
        name: 'Visa',
        description: 'free of charge',
        logo: {
            code: 'string',
            catalogId: 'string',
            catalogVersion: 'string',
            mime: 'string',
            altText: 'string',
            description: 'string',
            url: 'string',
            downloadUrl: 'string',
        },
        position: 3,
    },
    {
        code: 'mastercard',
        name: 'Mastercard',
        description: 'free of charge',
        logo: {
            code: 'string',
            catalogId: 'string',
            catalogVersion: 'string',
            mime: 'string',
            altText: 'string',
            description: 'string',
            url: 'string',
            downloadUrl: 'string',
        },
        position: 1,
    },
    {
        code: 'giftcard',
        name: 'Giftcard',
        description: 'Giftcard',
        logo: null,
        position: 0,
    },
    {
        code: 'payWithPoints',
        name: 'PayWithPoints',
        description: 'Pay With Points',
        position: 0,
    },
];

export const giftCardMethods = [
    {
        name: 'postilion',
        length: 13,
        regexes: [/^(920|921|922|925|926|927|930)\d{10}$/],
        helperContent: '',
        extraFields: [],
    },
];
